import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { closeNotification, displayNotification, handleNotification } from 'notification/actions';
import NotificationContainer from 'notification/NotificationContainer';

const NotificationApp = withRouter(
  connect(
    (state) => ({
      listOfNotifications: state?.notification?.listOfNotifications,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          displayNotification,
          closeNotification,
          handleNotification,
        },
        dispatch,
      ),
  )(NotificationContainer),
);

export default NotificationApp;
